module.exports = __webpack_public_path__ + "static/media/24UHCHR11.27a53246.jpg";